export function removeBase64Prefix(data: string): string {
  return data.split('base64,')?.[1] ?? '';
}
